
import { Container } from '@mui/material'
import RegisterAccess from '../../../../utils/registerAccess';
import HeaderSession from '../../../../utils/headerSession';
import CardOpcoes from '../../../../utils/cardOpcoes';

export default function OpcoesControlQualidade() {

    return (
        <Container style={{ minHeight: '73vh', }}>
            <RegisterAccess page={'Opções Controlo de Qualidade'} />
            <HeaderSession title={'CONTROLO DE QUALIDADE'} />

            <div style={{ padding: 20, display: 'flex', gap: '10px', flexDirection: 'column' }}>
                <CardOpcoes disabled={false} nomeService='Solicitação de Analise Laboratorial' link={'/formulario-de-solicitacao-de-analise-laboratorial'} />
                <CardOpcoes disabled={true} nomeService='Informaçōes Sobre Controlo de Qualidade' link={'/controle-de-qualidade'} />
                <CardOpcoes disabled={true} nomeService='Produtos Conforme Analisados Pelo LNCQM' link={''} />
                <CardOpcoes disabled={true} nomeService='Produtos Não Conforme  Analisados Pelo LNCQM' link={''} />
                <CardOpcoes disabled={true} nomeService='Despachos De Proibição ou Retiradas' link={''} />
            </div>
        </Container>
    )
}
